// Hide the default cookie renew icon
// Instead we use an anchor link to determine if it should open
// If anchor link #cookies is present, we simulate clicking the button

const removeHash = () => {
	history.pushState(
		'',
		document.title,
		window.location.pathname + window.location.search
	)
}

const setupCookieLinkListener = () => {
	// Detect if url changes and simulate clicking the button
	const checkForCookieHash = () => {
		const renewButton = document.getElementById('Coi-Renew')
		if (!renewButton) return
		const hash = window.location.hash
		if (hash === '#cookies') {
			renewButton.click()
			// Remove hash
			removeHash()
		}
	}
	checkForCookieHash()

	addEventListener('hashchange', checkForCookieHash)
}

setupCookieLinkListener()
